import React, { Fragment, useState } from "react";
import { Card, CardBody, Col, Input } from "reactstrap";
import { P, Btn } from "../../../../AbstractElements";
import { ClipboardonText, Copy, Cut, Cutandcopytext } from "../../../../Constant";
import HeaderCard from "../../../Common/HeaderCard";
const ClipboardText = () => {
  const [inputValue, setInputValue] = useState("");

  const handleCopy = async () => {
    await navigator.clipboard.writeText(inputValue);
    setInputValue(inputValue);
  };
  const handleCut = async () => {
    await navigator.clipboard.writeText(inputValue);
    setInputValue("");
  };
  return (
    <Fragment>
      <Col sm="12" md="6">
        <Card>
          <HeaderCard title={ClipboardonText} />
          <CardBody>
            <div className="clipboaard-container">
              <P className="card-description">{Cutandcopytext}</P>
              <Input className="form-control" id="clipboardExample1" type="text" placeholder="type some text to copy / cut" value={inputValue} onChange={({ target: { value } }) => setInputValue(value)} />
              <div className="mt-3 text-end">
                <Btn color="primary btn-clipboard me-1" onClick={handleCopy}>
                  <i className="fa fa-copy"></i> {Copy}
                </Btn>
                <Btn color="secondary btn-clipboard-cut" onClick={handleCut}>
                  <i className="fa fa-cut"></i> {Cut}
                </Btn>
              </div>
            </div>
          </CardBody>
        </Card>
      </Col>
    </Fragment>
  );
};
export default ClipboardText;
